import React from 'react';
import { Button, CheckPicker, Drawer, SelectPicker, Stack } from 'rsuite';

const FilterDrawer = ({
  showDrawer,
  setShowDrawer,
  head,
  label,
  //data states
  categorydata,
  productypedata,
  colordata,
  proNamedata,
  skudata,
  buyernamedata,
  finishdata,
  aliasdata,
  searchdata,
  proDdata,
  madedata,
  hsndata,
  materialdata = undefined,
  setCategorydata,
  setIsLoadingc = undefined,
  isLoadingc = undefined,
  SetIsLoadingTableData = undefined,
  setProgress = undefined,
  setColordata,
  isLoadingcolor,
  setIsLoadingcolor,
  setFinishData,
  isLoadingfin,
  setIsLoadingfin,
  setHsndata,
  isLoadinghsn,
  setIsLoadinghsn,
  setMaterialdata = undefined,
  isLoadingmat = undefined,
  setIsLoadingmat = undefined,
  //selectedstates
  selectedCategory,
  selectedProductType,
  selectedColor,
  selectedpron,
  selectedsku,
  selectedBuyer,
  selectedFinish,
  selectedAlias,
  selectedSearch,
  selectedpd,
  selectedmade,
  selectedhsn,
  selectedmaterial,
  selectedDateRange,
  selectedUpdatedDateRange,
  //onchangehandlers
  handleCategoryChange,
  handleProductTypeChange,
  handleColorChange,
  handleProNameChange,
  handleSkuChange,
  handleBuyerChange,
  handleFinishChange,
  handleAliasChange,
  handleSearchChange,
  handleProDChange,
  handleMadeChange,
  handleHSNChange,
  handleMaterialChange,
  handleDatechange,
  handleUpdatedDatechange,
  //onopenfunctions
  fetchCategory,
  fetchColors,
  fetchFinishes,
  fetchProductTypes,
  fetchAlias,
  fetchHsn,
  fetchMaterials,
  //rendermenus
  renderMenu2 = undefined,
  renderMenu5 = undefined,
  renderMenu1 = undefined,
  renderMenu = undefined,
  renderMenu3 = undefined,
  renderMenu4 = undefined,
}) => {
  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));

  return (
    <Drawer size="xs" open={showDrawer} onClose={() => setShowDrawer(false)}>
      <Drawer.Header style={{ marginBottom: '10px' }}>
        <Drawer.Title>Filters</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={() => setShowDrawer(false)} appearance="primary" color="cyan">
            Confirm
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Stack direction="column" alignItems="center">
          {head.some(item => item.FilterName === 'Category' && item.filterstatus == false) && (
            <CheckPicker
              data={categorydata}
              placeholder={` ${label[0]?.attributes.Category}`}
              value={selectedCategory}
              onChange={handleCategoryChange}
              style={{ width: 350, marginBottom: 20, marginTop: 20 }}
              // onOpen={() => fetchCategory( setCategorydata, setIsLoadingc, isLoadingc, SetIsLoadingTableData, setProgress)}
              menuStyle={{ maxWidth: 300 }}
            />
          )}
          {head.some(item => item.FilterName === 'ProductType' && item.filterstatus == false) && (
            <CheckPicker
              data={productypedata}
              placeholder={` ${label[0]?.attributes.ProductType}`}
              value={selectedProductType}
              onChange={handleProductTypeChange}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'Color' && item.filterstatus == false) && (
            <CheckPicker
              data={colordata}
              placeholder={` ${label[0]?.attributes.color}`}
              value={selectedColor}
              onChange={handleColorChange}
              style={{ width: 350, marginBottom: 20 }}
            // onOpen={fetchColors(setColorData,isLoadingcolor,setIsLoadingcolor)}
            />
          )}
          {head.some(item => item.FilterName === 'ProName' && item.filterstatus == false) && (
            <CheckPicker
              renderMenu={renderMenu2}
              value={selectedpron}
              onChange={handleProNameChange}
              data={proNamedata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.ProductName}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'BuyerStyle' && item.filterstatus == false) && (
            <CheckPicker
              renderMenu={renderMenu5}
              value={selectedsku}
              onChange={handleSkuChange}
              data={skudata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.BuyerSku}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'BuyerName' && item.filterstatus == false) && (
            <CheckPicker
              value={selectedBuyer}
              onChange={handleBuyerChange}
              data={buyernamedata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.BuyerName}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'Finish' && item.filterstatus == false) && (
            <CheckPicker
              value={selectedFinish}
              onChange={handleFinishChange}
              data={finishdata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.finish}`}
              style={{ width: 350, marginBottom: 20 }}
            // onOpen={fetchFinishes(setFinishData,isLoadingfin,setIsLoadingfin)}
            />
          )}
          {head.some(item => item.FilterName === 'AliasCode' && item.filterstatus == false) && (
            <CheckPicker
              data={aliasdata}
              placeholder={`${label[0]?.attributes.AliasCode}`}
              placement="autoVerticalStart"
              value={selectedAlias}
              onChange={handleAliasChange}
              style={{ width: 350, marginBottom: 20 }}
              renderMenu={renderMenu1}
            />
          )}
          {head.some(item => item.FilterName === 'SearchK' && item.filterstatus == false) && (
            <CheckPicker
              renderMenu={renderMenu}
              value={selectedSearch}
              onChange={handleSearchChange}
              data={searchdata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.searchKeyword}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'PDesign' && item.filterstatus == false) && (
            <CheckPicker
              renderMenu={renderMenu3}
              value={selectedpd}
              onChange={handleProDChange}
              data={proDdata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.ProductDesigner}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'MadeBy' && item.filterstatus == false) && (
            <CheckPicker
              renderMenu={renderMenu4}
              value={selectedmade}
              onChange={handleMadeChange}
              data={madedata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.MadeBy}`}
              style={{ width: 350, marginBottom: 20 }}
            />
          )}
          {head.some(item => item.FilterName === 'HSN' && item.filterstatus == false) && (
            <CheckPicker
              value={selectedhsn}
              onChange={handleHSNChange}
              data={hsndata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.HSN}`}
              style={{ width: 350, marginBottom: 20 }}
              onOpen={() => fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn)}
            />
          )}
          {head.some(item => item.FilterName === 'MaterialName' && item.filterstatus == false) && (
            <CheckPicker
              value={selectedmaterial}
              onChange={handleMaterialChange}
              data={materialdata}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.MaterialName}`}
              style={{ width: 350, marginBottom: 20 }}
              onOpen={() => fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat)}
            />
          )}
          {head.some(item => item.FilterName === "CreateOn" && item.filterstatus == false) && (
            <SelectPicker
              data={AddedOn}
              placement="autoVerticalStart"
              appearance="default"
              placeholder={`${label[0]?.attributes.addon}`}
              style={{ width: 350, marginBottom: 20 }}
              value={selectedDateRange}
              onChange={handleDatechange}
            />
          )}
          {head.some(item => item.FilterName === "UpdateOn" && item.filterstatus == false) && (
            <SelectPicker
              data={AddedOn}
              placement="autoVerticalStart"
              placeholder={`${label[0]?.attributes.updateon}`}
              style={{ width: 350, marginBottom: 20 }}
              value={selectedUpdatedDateRange}
              onChange={handleUpdatedDatechange}
            />
          )}
        </Stack>
      </Drawer.Body>
    </Drawer>
  );
};

export default FilterDrawer;
